import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyChartData } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-daily-distance',
  templateUrl: './daily-distance.component.html',
  styleUrls: ['./daily-distance.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintDailyDistanceComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  chartContext: ChartContext = {
    type: 'bar',
    title: 'مسافت پیموده‌شده',
    showTitle: false,
    data: [],
    colors: ['#6ca8ff'],
    unit: 'km',
    theme: 'dark',
  };

  ngOnChanges(): void {
    const data = buildDailyChartData(this.context.dailyMovement || [], this.context.dates || [], row => {
      const value = row.fDailyDistanceMean;
      return row.iRecordCount > 0 && typeof value === 'number'
        && Number.isFinite(value) && value >= 0 ? value : null;
    });
    this.chartContext = { ...this.chartContext, data };
  }
}
